module.exports = __webpack_public_path__ + "static/img/hero_header.4f28952.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero_header.svg
// module id = CvsF
// module chunks = 1